import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  {
    q: "Who needs to file GST returns?",
    a: "Any business with an annual turnover above ₹40 lakh (₹20 lakh for services) needs GST registration and must file returns monthly or quarterly. We help you determine your applicable slab and file on time.",
  },
  {
    q: "What documents do I need for ITR filing?",
    a: "Typically: PAN, Aadhaar, Form 16 (salaried), bank statements, investment proofs, capital gains statements and rent receipts. We provide a customised checklist based on your income sources.",
  },
  {
    q: "How much do your services cost?",
    a: "Our fees are transparent and fixed based on service. Individual ITR filings start from ₹999, GST monthly filings from ₹499. Contact us for a personalised quote — no obligation.",
  },
  {
    q: "Can I file taxes from outside Tumakuru?",
    a: "Absolutely. We serve clients across Karnataka and India remotely. Documents can be shared securely over email or WhatsApp and all filings are handled online.",
  },
  {
    q: "What is the deadline for ITR filing this year?",
    a: "For individuals, the standard due date is 31st July. For businesses under audit, it's 31st October. Book a consultation early to avoid last-minute penalties.",
  },
  {
    q: "Do you help with GST notices and tax scrutiny?",
    a: "Yes. We respond to GST notices, income tax scrutiny, TDS defaults and assessments — with full documentation and representation before authorities.",
  },
];

export const Faq = () => {
  return (
    <section
      id="faq"
      className="relative border-b border-border bg-secondary/30 py-24 md:py-32"
      data-testid="faq-section"
    >
      <div className="container mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-16">
          <div className="md:col-span-4">
            <div className="sticky top-28">
              <div className="mb-4 flex items-center gap-3">
                <span className="h-px w-10 bg-primary" />
                <span className="font-[Outfit] text-xs font-bold uppercase tracking-[0.2em] text-primary">
                  FAQ
                </span>
              </div>
              <h2 className="text-4xl font-extrabold leading-tight tracking-tight text-foreground md:text-5xl">
                Questions,<br />
                <span className="italic text-primary">answered.</span>
              </h2>
              <p className="mt-6 text-base text-muted-foreground">
                Can&apos;t find what you&apos;re looking for? Give us a call — real answers,
                no jargon.
              </p>
              <a
                href="tel:7353626623"
                className="mt-6 inline-block border-b-2 border-primary pb-1 font-[Outfit] text-sm font-bold uppercase tracking-wider text-primary hover:text-foreground"
                data-testid="faq-call-link"
              >
                Call 73536 26623 →
              </a>
            </div>
          </div>

          <div className="md:col-span-8">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-border"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="py-6 text-left font-[Outfit] text-lg font-semibold text-foreground hover:text-primary hover:no-underline md:text-xl">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-base leading-relaxed text-muted-foreground">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
